import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const SupportDataSlice = createSlice({
    name: "Support",
    initialState,
    reducers: {
        getSupportRequest(state) {
            state.loading = true;
        },
        getSupportRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getSupportRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getSupportRequest,
    getSupportRequestSuccess,
    getSupportRequestError,
} = SupportDataSlice.actions;

export default SupportDataSlice.reducer;
